export const LOGIN_SUCCESS = "LOGIN_SUCCESS";
export const LOGIN_FAILURE = "LOGIN_FAILURE";
export const LOGOUT = "LOGOUT";
export const START_REFRESH_INTERVAL = "START_REFRESH_INTERVAL";
export const STOP_REFRESH_INTERVAL = "STOP_REFRESH_INTERVAL";
export const AUTH_TOKEN_REFRESH = "AUTH_TOKEN_REFRESH";
export const AUTH_NOTIFICATION_REFRESH = "AUTH_NOTIFICATION_REFRESH";
export const AUTH_UPDATE_SETTING_DATETIME = "AUTH_UPDATE_SETTING_DATETIME";

export const FETCH_APP_SETTINGS = "FETCH_APP_SETTINGS";
export const SET_APP_SETTINGS = "FETCH_APP_SETTINGS";
export const REMOVE_APP_SETTINGS = "REMOVE_APP_SETTINGS";
export const SET_PAGE_SETTINGS = "SET_PAGE_SETTINGS";

export const SET_ALERT_ERROR = "SET_ALERT_ERROR";
export const SET_ALERT_ERROR_LIST = "SET_ALERT_ERROR_LIST";
export const SET_ALERT_SUCCESS = "SET_ALERT_SUCCESS";
export const RESET_ALERT = "RESET_ALERT";

export const SET_ERROR = "SET_ERROR";
export const CLEAR_ERROR = "CLEAR_ERROR";

export const FETCH_APP_SELECT_OPTIONS_PENDING =
  "FETCH_APP_SELECT_OPTIONS_PENDING";
export const FETCH_APP_SELECT_OPTIONS_SUCCESS =
  "FETCH_APP_SELECT_OPTIONS_SUCCESS";
export const FETCH_APP_SELECT_OPTIONS_ERROR = "FETCH_APP_SELECT_OPTIONS_ERROR";

export const START_LOADING = "START_LOADING";
export const START_COMPONENT_LOADING = "START_COMPONENT_LOADING";
export const STOP_LOADING = "STOP_LOADING";
export const STOP_COMPONENT_LOADING = "STOP_COMPONENT_LOADING";

export const SET_BUTTON_PROCESSING = "SET_BUTTON_PROCESSING"
export const CLEAR_BUTTON_PROCESSING = "CLEAR_BUTTON_PROCESSING"
export const RESET_BUTTON_PROCESSING = "RESET_BUTTON_PROCESSING"
